__turbopack_context__.v({
  "container": "hRAucW_container",
  "content": "hRAucW_content",
  "dashboard": "hRAucW_dashboard",
  "footer": "hRAucW_footer",
  "headerTabButton": "hRAucW_headerTabButton",
  "headerTabs": "hRAucW_headerTabs",
  "selected": "hRAucW_selected",
});
